// Simple centered modal with header, body, and footer actions. Closes on
// backdrop click or the ✕. Rendered into <body> (portal) so it never
// inherits styles from where it's opened, e.g. a nowrap / right-aligned
// table cell.
import { createPortal } from 'react-dom';

export default function Modal({ title, onClose, children, footer, width }) {
  return createPortal(
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card" style={width ? { width } : undefined} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div className="modal-title">{title}</div>
          <button className="btn btn-sm" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && (
          <div className="modal-head" style={{ borderTop: '1px solid var(--border)', borderBottom: 'none', justifyContent: 'flex-end', gap: 8 }}>
            {footer}
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
}
